import '@babel/polyfill'

import {
  LineChart,
  EventsChart,
} from './charts'

import {
  scaleOrdinal,
  scaleTime,
} from 'd3-scale'
import { extent } from 'd3-array'
import { csvParse } from 'd3-dsv'
import { select } from 'd3-selection'

const d3 = {
  csvParse,
  scaleOrdinal,
  scaleTime,
  extent,
  select,
}

const csv = require('./data/fig1.csv')
const triggerCsv = require('./data/fig1_triggers.csv')
const lineA = require('./data/fig9a.csv')
const lineB = require('./data/fig9b.csv')
const lineC = require('./data/fig9c.csv')
const lineD = require('./data/fig9d.csv')

// ===============
//     Chart 1
// ===============

let eventsChart, lineCharts = []

function placeCharts() {

  let eventsData = d3.csvParse(csv),
    triggerData = d3.csvParse(triggerCsv)

  let panicData = [],
    balanceSheetData = []

  eventsData.columns.forEach((key) => {
    if(key == 'date') return

    if( key == 'Subprime') {

      let d = {
        title: key,
        values: eventsData.slice(11).map((d) => ({
          y: d[key],
          x: new Date( d.date )
        }))
      }

      balanceSheetData.push(d)

    } else {

      let d = {
        title: key,
        values: eventsData.slice(11).map((d) => ({
          y: d[key],
          x: new Date( d.date )
        }))
      }

      panicData.push(d)

    }
  })

  triggerData = triggerData.map((trigger) => ({
    title: trigger.title,
    date: new Date( trigger.date ),
  }))

  const chartData = {
    panicData,
    balanceSheetData,
    triggerData,
  }


  const eventsChartId = 'BPEA-eventsChart'
  d3.select( '#' + eventsChartId + '-wrapper' ).append('svg').attr('id', eventsChartId)

  let colors = [ '#FB986A', '#DD5446', '#8094AD', '#053769' ]

  let colorScale = d3.scaleOrdinal()
      .domain( [ 'Funding', 'Nonmortgage Credit', 'Bank Solvency', 'Subprime' ] )
      .range( colors )

  eventsChart = new EventsChart({
    colors: colorScale,
    padding: {
      left: 47,
      bottom: 50,
      top: 50,
      right: 60,
    },
    yAxis1Label: 'Percent',
    yAxis2Label: 'Index Level',
    xAxisLabel: '',
    showAxisLines: false,
    xAxisPadding: 8,
    yAxisPadding: 8,
    xScale: d3.scaleTime().domain(d3.extent(chartData.panicData[0].values, (d) => d.x )),
    showTooltip: false,
    showLegend: true,
    strokeWidth: 2,
    height: 300,
    yTicks: 5,
    animate: true,
  }, chartData, eventsChartId)

  eventsChart.draw()

  // ===============
  //     Chart 2
  // ===============

  const lineChartsData = [ lineA, lineB, lineC, lineD ]

  const data = lineChartsData.map((d) => d3.csvParse(d))

  data.forEach((data,i) => {

    const id = 'BPEA-lineChart-' + i

    d3.select( '#' + id + '-wrapper' ).append('svg').attr('id', id)

    let lineData = []

    data.columns.forEach((key) => {
      if(key == 'date') return

      lineData.push({
        title: key,
        values: data.map((d) => ({
          y: d[key],
          x: new Date( d.date )
        }))
      })
    })

    const colors = [ '#183D6C', '#0B7A5A', '#AB500A', '#AC8F0A' ],
      colorScale = d3.scaleOrdinal()
        .domain( lineData.map((d) => d.title) )
        .range( [ colors[i], 'rgba(215,48,31,0.4)', 'rgba(24,61,109,0.4)' ] )

    const line = new LineChart({
      colors: colorScale,
      padding: {
        left: 50,
        bottom: 50,
        top: 50,
      },
      yAxisLabel: 'Percent',
      xAxisLabel: '',
      xScale: d3.scaleTime().domain(d3.extent(lineData[0].values, (d) => d.x )),
      yTicks: 4,
      showTooltip: false,
      showLegend1: !i,
      showLegend2: true,
      strokeWidth: 2,
      height: 250,
      showTickValues: true,
      showTickLines: true,
      showAxisLines: false,
      xAxisPadding: 8,
      yAxisPadding: 8,
    }, lineData, id)

    line.draw()

    lineCharts.push( line )

  })

  window.onresize = function() {
    lineCharts.forEach((line) => {
      line.draw()
    })

    eventsChart.draw()
  }

  let interval = setInterval(() => {
    let el = document.getElementById( eventsChart.id ),
      scrollPos = window.scrollY,
      elTop = el.getBoundingClientRect().top,
      elBottom = el.getBoundingClientRect().bottom,
      elHeight = el.getBoundingClientRect().height

    if( (elTop < window.innerHeight - elHeight/3) &&
      (elBottom > elHeight/3) &&
      eventsChart.animate ) {

      eventsChart.animate()
      clearInterval( interval )

    }

    lineCharts.forEach((line) => {
      let c = document.getElementById( line.id )
      c.style.width = '99.9%'
    })

    let c = document.getElementById( eventsChart.id )
    c.style.width = '99.9%'


  }, 50)

}

document.addEventListener('readystatechange', function() {

  if( document.readyState == 'complete' ) {

    placeCharts()

  }

}, false)
